import Super from '../-resources';

export default class SiteBillingInsuranceNew extends Super {}
